module.exports = __webpack_public_path__ + "media/images/number_8-2616efd912081404dadb1a8e9e254a68.png";